import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConnectivityService } from './core/offline/connectivity.service';
import { SyncService } from './core/offline/sync.service';
import { ToastOutletComponent } from './shared/ui/toast-outlet/toast-outlet.component';
import { AutoTranslateDirective } from './shared/directives/auto-translate.directive';
import { ConfirmDialogComponent } from './shared/ui/confirm-dialog/confirm-dialog.component';
import { PwaInstallPromptComponent } from './shared/ui/pwa-install-prompt/pwa-install-prompt.component';
import { PwaInstallService } from './core/pwa/pwa-install.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastOutletComponent, AutoTranslateDirective, ConfirmDialogComponent, PwaInstallPromptComponent],
  template: `
    <div lemAutoTranslate>
      <router-outlet />
      <lem-toast-outlet />
      <lem-confirm-dialog />
      <lem-pwa-install-prompt />
    </div>
  `,
})
export class App {
  // Injection volontaire dès le bootstrap (même si non utilisés dans le
  // template) : garantit que la détection de connectivité et la file de
  // synchronisation démarrent immédiatement, y compris sur l'écran de
  // connexion, avant même toute navigation dans le shell applicatif.
  private readonly connectivity = inject(ConnectivityService);
  private readonly sync = inject(SyncService);
  private readonly pwa = inject(PwaInstallService);
}
